
import Vue from 'vue'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import PointCard from '../point-card/index.vue'

export default Vue.extend({
  name: 'PointMap',
  components: {
    // eslint-disable-next-line vue/match-component-import-name
    yandexMap,
    // eslint-disable-next-line vue/match-component-import-name
    ymapMarker,
    PointCard
  },
  props: {
    region: {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    shops: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    hideButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selectedPointId: null
    }
  },
  computed: {
    selectedPoint () {
      return this.region?.shops?.find((point: { id }) => point.id === this.selectedPointId)
    }
  },
  methods: {
    selectPoint (id: number) {
      this.selectedPointId = id
    },

    parseCardTypes () {
      return this.cardTypes?.split(',')?.map((type, idx, arr) => type + (idx === arr?.length - 1 ? '' : ','))
    },

    closeMarkerPopup () {
      this.selectedPointId = null
    }
  }
})
